import React, { useState } from 'react';

import BillsTable from '../components/bill/billsTable'

function Bill(props) {
    const [searchValue, setSearchValue] = useState('')

    const handleSearch = (e, data) => {
        if(e.key == 'Enter'){
        setSearchValue(e.target.value)
        }
    }
    
    return (
        <React.Fragment>
            <div className="ag=theme-material agOver">
                <BillsTable handleSearch={handleSearch} searchValue={searchValue} {...props} />
            </div>
        </React.Fragment>
    )
}


export default Bill